var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0H5C2.243 0 0 2.243 0 5V19C0 21.757 2.243 24 5 24H13C15.757 24 18 21.757 18 19V5C18 2.243 15.757 0 13 0ZM9 17H5C4.447 17 4 16.553 4 16C4 15.447 4.447 15 5 15H9C9.553 15 10 15.447 10 16C10 16.553 9.553 17 9 17ZM13 12H5C4.447 12 4 11.553 4 11C4 10.447 4.447 10 5 10H13C13.553 10 14 10.447 14 11C14 11.553 13.553 12 13 12ZM13 7H5C4.447 7 4 6.553 4 6C4 5.447 4.447 5 5 5H13C13.553 5 14 5.447 14 6C14 6.553 13.553 7 13 7Z",
    fill: "#DCDCDC",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.7155dfdd6e5d29dfc419d5fdf007832d.svg";
export { ForwardRef as ReactComponent };